export default {
    firstToCreate: 'このフォーラムで最初にスレッドを作成しましょう',
    firstToPostInCategory: 'このカテゴリで最初に投稿しましょう',
    firstToRespondToTopic: 'このトピックに最初に返信しましょう！',
    createNewThread: '新しいスレッドを作成',
    thread: 'スレッド',
    viewThread: 'スレッドを表示',
    replies: '返信',
    noReplies: '返信なし',
    reply: '返信',
    _reply: '返信',
    ReplyTo: '返信先',
    replyToThisQuestion: 'この質問に返信する',
    onceRepliedModeratorMayRespond: '返信すると、フォーラムモデレーターが返信することがあります',
    onceRepliedCanViewResponses: '返信すると、他の参加者の回答を閲覧できます',
    loadingResponses: '返信を読み込み中',
    hideXReplies: '{count} 件の返信を非表示',
    showXReplies: '{count} 件の返信を表示',
    hideMostRecentReplies: '最新の返信を非表示',
    showMostRecentReplies: '最新の返信を表示',
    post: '投稿',
    message: 'メッセージ',
    typeMessage: 'メッセージを入力',
    addPost: '投稿を追加',
    addMessage: 'メッセージを追加',
    editPost: '投稿を編集',
    editPostWithMedia: 'メディア付き投稿を編集',
    createPostWithMedia: 'メディア付き投稿を作成',
    deleteMessage: 'メッセージを削除',
    deleteMessageConfirm: 'このメッセージを削除してもよろしいですか？',
    pinPost: '投稿をピン留め',
    media: 'メディア',
    uploadMedia: 'メディアをアップロード',
    categories: 'カテゴリ',
    goBack: '戻る',
    goBackPrevious: '前のページに戻る',
    goBackToCategory: '{name} カテゴリに戻る',
    loadingLatestThreads: '最新のスレッドを読み込み中',
    loadingDiscussionForum: 'ディスカッションフォーラムを読み込み中',
    dontShowAgainForTask: 'このタスクでは再表示しない',
    title: 'タイトル',
    beTheFirst: 'Be the first to reply to this thread'
};
